import { Link } from "react-router-dom";
import { Unplug } from "lucide-react";
import { relTime } from "../lib/format";

export const fbBroken = (h) => h && h.status === "error";

export default function FbHealthBanner({ health, pageName }) {
  if (!fbBroken(health)) return null;
  return (
    <section className="fb-alert" role="alert" data-testid="fb-health-banner">
      <span className="fa-icon" aria-hidden="true">
        <Unplug size={20} />
      </span>
      <div className="fa-text">
        <b>
          Din Facebook-side {pageName ? `«${pageName}» ` : ""}har mistet forbindelsen til JaTak Pro.
        </b>
        <span>Nye "ja tak"-kommentarer bliver ikke besvaret, og opslag bliver ikke lagt op.</span>
        <small data-testid="fb-health-reason">
          {health.reason}
          {health.since ? ` · siden ${relTime(health.since)}` : ""}
        </small>
      </div>
      <Link className="btn primary fa-btn" to="/settings#facebook" data-testid="fb-health-reconnect">
        Forbind igen
      </Link>
    </section>
  );
}
